import { Button, DataSource, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionPickList extends Layout {
    DelItemButton: Button;
    PdfTifSwitch: Switch;
    ProcessButton: Button;
    panel1: Panel;
    sourceProcbills: DataSource;
    table1: Table;
    txtOrder: Textbox;
}
